import { http } from '../../../../api/http';
import type { GuiaSalida } from '../types/guiaSalida.types';

export const guiaSalidaService = {
  async getAll(): Promise<GuiaSalida[]> {
    const response = await http.get('/inventario/guia-salida');
    return response.data;
  },

  async getById(id: number): Promise<GuiaSalida> {
    const response = await http.get(`/inventario/guia-salida/${id}`);
    return response.data;
  },

  async save(guia: Partial<GuiaSalida>): Promise<GuiaSalida> {
    const response = await http.post('/inventario/guia-salida', guia);
    return response.data;
  },

  async delete(id: number): Promise<void> {
    await http.delete(`/inventario/guia-salida/${id}`);
  },
};
